import React from "react";

// PropChain app already includes QueryClientProvider internally
import App from "./propchain/App.tsx";

export default function PropChainApp() {
  return <App />;
}
